import { getServiceTypePending, getServiceTypeSuccess, getServiceTypeFail, 
    deleteServiceTypePending, deleteServiceTypeSuccess, deleteServiceTypeFail,
    getSServiceTypePending, getSServiceTypeSuccess, getSServiceTypeFail, 
    createServiceTypePending, createServiceTypeSuccess, createServiceTypeFail, 
    modifyServiceTypePending, modifyServiceTypeSuccess, modifyServiceTypeFail } from "./serviceTypeSlice";
import { fetchAllServiceType, serviceTypeDelete, serviceTypeCreation, serviceTypeModify, fetchSingleServiceType } from "../../../api/userApi";
import Swal from "sweetalert2";

export const getAllServiceType = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getServiceTypePending());
        const result = await fetchAllServiceType();
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

        //console.log('allCityData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const serviceTypedetails = JSON.parse(JSON.stringify(myObj.servicetypes));
        const serviceTypedetails1 = JSON.parse(JSON.stringify(serviceTypedetails));
        
        if (serviceTypedetails) {
        
            return dispatch(getServiceTypeSuccess(serviceTypedetails));
        }
        dispatch(getServiceTypeFail("Service is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getServiceTypeFail(err.msg));

    }
}

export const serviceTypeDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteServiceTypePending());
        const result = await serviceTypeDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteServiceTypeSuccess("Service deleted"))
        : dispatch(deleteServiceTypeFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteServiceTypeFail(err.msg));
    }
    
}

export const newServiceTypeCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createServiceTypePending());
        const result = await serviceTypeCreation(frmDt);
        //console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createServiceTypeSuccess(result.message))
            : dispatch(createServiceTypeFail(result.message));

           // console.log("CountryCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
         //console.log("catch block");
         console.log(error);
         if(error.response.status===401){}
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error');
        dispatch(createServiceTypeFail());
       //  console.log(err);
        // console.log('disp');
        // console.log(err.msg);
       
    //    const row = err.map((er, i) => {
    //     console.log('loop');
    //     console.log(er.msg);
    //     console.log('loop param');

    //     console.log(er.param);
    //         if (i === er.length - 1) {
    //           return er.param+' '+er.msg+'. ';
    //         }
    //         return er.param+' '+er.msg+' ';
    //       });
    //       console.log('row');
    //       console.log(row);
         
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
       
       
       
    }

}

export const getSingleServiceType = (id) => async (dispatch) => {
    
 
 console.log('service id : '+id);
    try {
     //call the api
    dispatch(getSServiceTypePending());
    const result = await fetchSingleServiceType(id);
   // const userData=JSON.parse(result.user);
 console.log('ServiceTypeData ');
 //console.log(result);
 console.log(result.servicetypes);
 
 //console.log('check user profile out if');
    if(result.servicetypes[0] && result.servicetypes[0].id){
    //console.log('check user profile');
        return dispatch(getSServiceTypeSuccess(result.servicetypes[0]));
    }
    dispatch(getSServiceTypeFail("Service is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
    console.log(err.msg);
    dispatch(getSServiceTypeFail(err.msg));
 
 }
    
 
 }




export const serviceTypeModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyServiceTypePending());
        const result = await serviceTypeModify(frmDt);
        result.status === "success"
            ? dispatch(modifyServiceTypeSuccess(result.message))
            : dispatch(modifyServiceTypeFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error');    
        dispatch(modifyServiceTypeFail());
    }

}
